import React from "react";

export function HeaderThesaurusIcon(props) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_409_202"
        style={{ maskType: "alpha" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_409_202)">
        <path
          d="M7.5 22C6.51667 22 5.6875 21.6625 5.0125 20.9875C4.3375 20.3125 4 19.4833 4 18.5V5.5C4 4.53333 4.3375 3.70833 5.0125 3.025C5.6875 2.34167 6.51667 2 7.5 2H20V17C19.5667 17 19.2083 17.1458 18.925 17.4375C18.6417 17.7292 18.5 18.0833 18.5 18.5C18.5 18.9333 18.6417 19.2917 18.925 19.575C19.2083 19.8583 19.5667 20 20 20V22H7.5ZM7.5 20H16.825C16.725 19.7667 16.6458 19.5292 16.5875 19.2875C16.5292 19.0458 16.5 18.7833 16.5 18.5C16.5 18.2333 16.525 17.975 16.575 17.725C16.625 17.475 16.7083 17.2333 16.825 17H7.5C7.06667 17 6.70833 17.1458 6.425 17.4375C6.14167 17.7292 6 18.0833 6 18.5C6 18.9333 6.14167 19.2917 6.425 19.575C6.70833 19.8583 7.06667 20 7.5 20ZM6 15.325C6.23333 15.2083 6.47083 15.125 6.7125 15.075C6.95417 15.025 7.21667 15 7.5 15H18V4H7.5C7.06667 4 6.70833 4.14583 6.425 4.4375C6.14167 4.72917 6 5.08333 6 5.5V15.325ZM8.725 13H9.95L10.575 11.225H13.4L14.025 13H15.25L12.6 6H11.35L8.725 13ZM10.925 10.2L11.95 7.3H12.025L13.05 10.2H10.925Z"
          fill="#36355A"
        />
      </g>
    </svg>
  );
}
